/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Fri Mar 19 2021 11:55:02 GMT+0100 (czas środkowoeuraopejski standardowy)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.ACCOUNTING;

export interface ACCList {
  accattribute: string;
  acclabel: string;
  accmodel: string;
  accountingdate: string;
  accountingreference: string;
  accreference: string;
  accsublabel: string;
  accsubreference: string;
  aceid: number;
  credit: number;
  debit: number;
  externalreference: string;
  jobidaudit: number;
  linelabel: string;
  objectid: number;
  objectlabel: string;
  schid: number;
  schlineorder: number;
  schoperation: string;
  sclinejournal: string;
}

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface AccAudit {
  accid: number;
  accmodel: string;
  accountingdate: string;
  accountingreference: string;
  accreference: string;
  accsubid: number;
  accsubreference: string;
  aceid: number;
  assettype: string;
  auditdate: string;
  auditid: number;
  auxiliarycode: string;
  axe1: string;
  axe2: string;
  axe3: string;
  axe4: string;
  axe5: string;
  companycode: string;
  ctreference: string;
  ctrid: number;
  currcode: string;
  externalreference: string;
  extractdate: string;
  extractfilename: string;
  extracttext: string;
  jobid: number;
  jobidbalance: number;
  jobidextract: number;
  mgid: number;
  objectlabel: string;
  offerid: number;
  paymentmode: string;
  percode: string;
  prcode: string;
  schid: number;
  schlinedirection: string;
  schoperation: string;
  sclineamount: number;
  sclinejournal: string;
  taxcode: string;
  tpid: number;
  tpreference: string;
  tprole: string;
}

export interface AccBalance {
  accid: number;
  accmodel: string;
  accreference: string;
  accsubid: number;
  accsubreference: string;
  auxiliarycode: string;
  axe1: string;
  axe2: string;
  axe3: string;
  axe4: string;
  axe5: string;
  balendamount: number;
  balid: number;
  balstartamount: number;
  baltotalcredit: number;
  baltotaldebit: number;
  calculationdate: string;
  companycode: string;
  ctreference: string;
  ctrid: number;
  currcode: string;
  jobid: number;
  mgid: number;
  offerid: number;
  percode: string;
  prcode: string;
  sclinejournal: string;
  tpid: number;
  tpreference: string;
  tprole: string;
}

export interface AccEvents {
  accmodel: string;
  accountingdate: string;
  accountingreference: string;
  assetid: number;
  bookgainorloss: number;
  bookvalue: number;
  created_at: string;
  ctedirection: string;
  cteid: number;
  cteupfront: number;
  ctrid: number;
  currcode: string;
  eventcategory: string;
  eventdate: string;
  eventid: number;
  eventidparent: number;
  eventstatus: string;
  eventtype: string;
  finamount: number;
  fingainorloss: number;
  fiscalbookvalue: number;
  grossamount: number;
  jobid: number;
  mgid: number;
  netamount: number;
  objectcat: string;
  objecttype: string;
  offerid: number;
  payid: number;
  postingdate: string;
  prcode: string;
  residualvalue: number;
  siid: number;
  socialbookvalue: number;
  taxamount: number;
  updated_at: string;
}

export interface AccEventsResponse {
  accmodel: string;
  accountingdate: string;
  accountingreference: string;
  assetid: number;
  bookgainorloss: number;
  bookvalue: number;
  created_at: string;
  ctedirection: string;
  cteid: number;
  cteupfront: number;
  ctrid: number;
  currcode: string;
  eventcategory: string;
  eventdate: string;
  eventid: number;
  eventidparent: number;
  eventstatus: string;
  eventtype: string;
  finamount: number;
  fingainorloss: number;
  fiscalbookvalue: number;
  grossamount: number;
  jobid: number;
  mgid: number;
  netamount: number;
  objectcat: string;
  objecttype: string;
  offerid: number;
  payid: number;
  postingdate: string;
  prcode: string;
  residualvalue: number;
  siid: number;
  socialbookvalue: number;
  taxamount: number;
  updated_at: string;
  objectreference: string;
  eventtypelabel: string;
}

export interface AccPeriodResponse {
  execode: string;
  percode: string;
  perenddate: string;
  permonth: number;
  perstartdate: string;
  perstatus: string;
  perstatusdate: string;
  perstatuslabel: string;
  peryear: number;
}

export interface BatchJobExecution {
  create_time: string;
  end_time: string;
  errorfile: string;
  exit_code: string;
  exit_message: string;
  job_configuration_location: string;
  job_execution_id: number;
  job_instance_id: number;
  last_updated: string;
  logfile: string;
  logfolder: string;
  outputfile: string;
  outputfolder: string;
  serviceexecparam: string;
  servicename: string;
  start_time: string;
  status: string;
  userid: number;
  version: number;
}

export interface EntriesResponse {
  accmodel: string;
  accmodellabel: string;
  accountingdate: string;
  accountingreference: string;
  accountingreferenceparent: string;
  assetid: number;
  assetreference: string;
  ciid: number;
  cireference: string;
  ctreference: string;
  ctrid: number;
  jobidaudit: number;
  payid: number;
  payreference: string;
  schoperation: string;
  schoperationlabel: string;
  siid: number;
  sireference: string;
}

export interface File {
  absolute: boolean;
  absoluteFile: File;
  absolutePath: string;
  canonicalFile: File;
  canonicalPath: string;
  directory: boolean;
  file: boolean;
  freeSpace: number;
  hidden: boolean;
  name: string;
  parent: string;
  parentFile: File;
  path: string;
  totalSpace: number;
  usableSpace: number;
}

export interface FinConElemSpreading {
  accountingdate: string;
  accountingreference: string;
  cteid: number;
  ctrid: number;
  ctsamortizedamount: number;
  ctscategory: string;
  ctsdirection: string;
  ctsduedate: string;
  ctsenddate: string;
  ctsid: number;
  ctsinterestamount: number;
  ctsnominalrate: number;
  ctsorder: number;
  ctsoutstandingamount: number;
  ctsrentalamount: number;
  ctsstartamount: number;
  ctsstartdate: string;
  ctsstatus: string;
  ctstype: string;
}

export interface Accprovision {
  accountingdate: string;
  accountingreference: string;
  assetinitamount: number;
  assetmarketvalue: number;
  currcode: string;
  flagtpclassupdate: boolean;
  guaramount: number;
  guarcoveragecoef: number;
  guarvalue: number;
  jobid: number;
  mgid: number;
  outstandingcapital: number;
  outstandinginterest: number;
  percode: string;
  provid: number;
  provisioncategory: string;
  provisioncategorylabel: string;
  provisioncoef: number;
  provstatus: string;
  totaldebt: number;
  totalprovision: number;
  tpid: number;
  tpinitclass: string;
  tptargetclass: string;
  unpaid1: number;
  unpaid120: number;
  unpaid150: number;
  unpaid180: number;
  unpaid210: number;
  unpaid240: number;
  unpaid270: number;
  unpaid30: number;
  unpaid300: number;
  unpaid330: number;
  unpaid360: number;
  unpaid45: number;
  unpaid60: number;
  unpaid90: number;
  unpaidmaxnbdays: number;
  updatedat: string;
  initclasslabel: string;
  targetclasslabel: string;
  updatedby: number;
  tpname: string;
  tpreference: number;
}

export interface AccprovisionDetail {
  assetid: number;
  assetmarketvalue: number;
  assetnetamount: number;
  ciid: number;
  cisamount: number;
  cisdueamount: number;
  cisduedate: string;
  cisid: number;
  ctrid: number;
  guaramount: number;
  guarid: number;
  guarvalue: number;
  linetype: string;
  nbdays: number;
  outstandingcapital: number;
  outstandinginterest: number;
  provid: number;
  provlineid: number;
  cireference: string;
  ctrreference: string;
}

export interface InputStream {}

export interface JobExecutionResponse {
  code: string;
  description: string;
  errorfile: string;
  jobid: number;
  logfile: string;
  message: string;
  outputfile: string;
  servicename: string;
}

export interface ParAccPeriod {
  execode: string;
  percode: string;
  perenddate: string;
  permonth: number;
  perstartdate: string;
  perstatus: string;
  perstatusdate: string;
  peryear: number;
}

export interface ParAccaccount {
  accclass: string;
  accclasslabel:string;
  accedescription: string;
  accid: number;
  acclabel: string;
  accmappingreference: string;
  accmodel: string;
  accmodellabel:string;
  accreference: string;
  acctype: string;
  acctypelabel:string;
  mgid: number;
}

export interface ParFunctionLabel {
  funcode: string;
  funlabel: string;
  funmodule: string;
  lancode: string;
}

export interface Paraccaccsubaccount {
  accdescription: string;
  accid: number;
  acclabel: string;
  accmappingreference: string;
  accreference: string;
  accsubid: number;
  applicationrule: string;
}

export interface Paraccattribute {
  accarttributelable: string;
  accattribute: string;
  attid: number;
  schoperation: string;
  sqlfunction: string;
  tabcolumn: string;
  tabkey: string;
  tabtable: string;
  tabwhere: string;
  entity:string;
}

export interface Paraccschema {
  accjournal: string;
  accmodel: string;
  acctype: string;
  mgid: number;
  schid: number;
  schlabel: string;
  schoperation: string;
  schoperationlabel: string;
}

export interface ParaccshemaResponse {
  accjournal: string;
  accjournallabel: string;
  accmodel: string;
  accmodellabel: string;
  acctype: string;
  acctypelabel: string;
  mgid: number;
  schid: number;
  schlabel: string;
  schoperation: string;
  schoperationLabel: string;
}

export interface ParaccschlineResponse {
  accReference: string;
  accattribute: string;
  accid: number;
  acclabel: string;
  applicationrule: string;
  attid: number;
  attlabel: string;
  axe1: string;
  axe2: string;
  axe3: string;
  axe4: string;
  axe5: string;
  schid: number;
  schlinedirection: string;
  schlineid: number;
  schlinejournal: string;
  schlinelabel: string;
  schlineorder: number;
}

export interface Paraccschline {
  accattribute: string;
  accid: number;
  applicationrule: string;
  axe1: string;
  axe2: string;
  axe3: string;
  axe4: string;
  axe5: string;
  schid?: number;
  schlinedirection?: string;
  schlineid?: number;
  schlinejournal?: string;
  schlinelabel?: string;
  schlineorder?: number;
}

export interface Resource {
  description: string;
  file: File;
  filename: string;
  inputStream: InputStream;
  open: boolean;
  readable: boolean;
  uri: URI;
  url: URL;
}

export interface URI {
  absolute: boolean;
  authority: string;
  fragment: string;
  host: string;
  opaque: boolean;
  path: string;
  port: number;
  query: string;
  rawAuthority: string;
  rawFragment: string;
  rawPath: string;
  rawQuery: string;
  rawSchemeSpecificPart: string;
  rawUserInfo: string;
  scheme: string;
  schemeSpecificPart: string;
  userInfo: string;
}

export interface ViewAssetDepreciation {
  accountingdate: string;
  accountingreference: string;
  assetcategory: string;
  assetid: number;
  assetlabel: string;
  assetnetamount: number;
  assetreference: string;
  assetrvamount: number;
  assettype: string;
  contextenddate: string;
  contextstartdate: string;
  ctreference: string;
  ctrid: number;
  deprcontext: string;
  deprlineid: number;
  deprmethod: string;
  durationmonths: number;
  perioddegressiveamount: number;
  periodendamount: number;
  periodenddate: string;
  periodlinearamount: number;
  periodstartamount: number;
  periodstartdate: string;
}

export interface GetParaccaccsubaccountByCriteriaParams {
  accid: number;
  acclabel: string;
  accmappingreference: string;
  accreference: string;
}
export interface Mgprovision {
  flagassetmarketvalue: boolean;
  flagguaranty: boolean;
  flagoutstandingcapital: boolean;
  flagoutstandinginterest: boolean;
  flagtax: boolean;
  initialclass: string;
  mgid: number;
  mgprovid: number;
  nbdays: number;
  nbdaysmax: number;
  provisioncoef: number;
  targetclass: string;
}

export interface MgprovisionResponse {
  flagassetmarketvalue: boolean;
  flagguaranty: boolean;
  flagoutstandingcapital: boolean;
  flagoutstandinginterest: boolean;
  flagtax: boolean;
  initialclass: string;
  initialclasslabel: string;
  mgid: number;
  mgname: string;
  mgprovid: number;
  nbdays: number;
  nbdaysmax: number;
  provisioncoef: number;
  targetclass: string;
  targetclasslabel: string;
}
export interface Acccuttoff {
  accountingreference: string;
  accoutingdate: string;
  adjustedoutstanding: number;
  calculationbasis: string;
  capitalinadvance: number;
  capitalinarrear: number;
  ctecategory: string;
  ctedescription: string;
  cteid: number;
  ctetype: string;
  ctreference: string;
  ctrid: number;
  ctsamortizedamount: number;
  ctsduedate: string;
  ctsenddate: string;
  ctsinterestamount: number;
  ctsinvoicedamount: number;
  ctsoutstandingamount: number;
  ctsstartamount: number;
  ctsstartdate: string;
  ctsterm: string;
  currcode: string;
  cutid: number;
  interestinadvance: number;
  interestinarrear: number;
  invoiceinadvance: number;
  invoiceinarrear: number;
  jobid: number;
  nbdayscutoff: number;
  nbdaysperiod: number;
  percode: string;
}
export interface AccCutOffResponse {
  accountingreference: string;
  accoutingdate: string;
  adjustedoutstanding: number;
  calculationbasis: string;
  capitalinadvance: number;
  capitalinarrear: number;
  ctecategory: string;
  ctecategorylabel: string;
  ctedescription: string;
  cteid: number;
  ctetype: string;
  ctetypelabel: string;
  ctreference: string;
  ctrid: number;
  ctsamortizedamount: number;
  ctsduedate: string;
  ctsenddate: string;
  ctsinterestamount: number;
  ctsinvoicedamount: number;
  ctsoutstandingamount: number;
  ctsstartamount: number;
  ctsstartdate: string;
  ctsterm: string;
  ctstermlabel: string;
  currcode: string;
  cutid: number;
  interestinadvance: number;
  interestinarrear: number;
  invoiceinadvance: number;
  invoiceinarrear: number;
  jobid: number;
  nbdayscutoff: number;
  nbdaysperiod: number;
  percode: string;
}

export interface ParAccExercice {
  execode: string;
  exeenddate: string;
  exestartdate: string;
  exestatus: string;
  exestatusdate: string;
  exeyear: string;
}
      
  
  
  export interface ParAccExerciceResponse {
  execode: string;
  exeenddate: string;
  exestartdate: string;
  exestatus: string;
  exestatusdate: string;
  exestatuslabel: string;
  exeyear: string;
}

export interface GetProvisionListByCriteriaParams {
  accountingreference: string;
  jobid: number;
  percode: string;
  provisioncategory: string;
  currcode: string;
  tpid: number;
}
export interface GetCutOffByIdParams {
  cutid: number;
}
export interface AccEntriesResponse {
  accattribute: string;
  accid: number;
  accmodel: string;
  accountingdate: string;
  accountingreference: string;
  accountingreferenceparent: string;
  accsubid: number;
  aceid: number;
  aceidparent: number;
  assetid: number;
  assetreference: string;
  assettype: string;
  auditdate: string;
  axe1: string;
  axe2: string;
  axe3: string;
  axe4: string;
  axe5: string;
  ciid: number;
  ctreference: string;
  ctrid: number;
  currcode: string;
  externalreference: string;
  extractdate: string;
  extracttext: string;
  jobid: number;
  jobidaudit: number;
  jobidextract: number;
  linelabel: string;
  mgid: number;
  nettingreference: string;
  networkcode: string;
  objectcategory: string;
  objectid: number;
  objectlabel: string;
  objectreference: string;
  objecttype: string;
  offerid: number;
  payid: number;
  paymentmode: string;
  prcode: string;
  schid: number;
  schlinedirection: string;
  schlineid: number;
  schlineorder: number;
  schoperation: string;
  sclineamount: number;
  sclinejournal: string;
  siid: number;
  taxcode: string;
  tpid: number;
  tpidbroker: number;
  tpidclient: number;
  tpidsupplier: number;
  tpreference: string;
  tprole: string;
  };

/**
 * @tags Accounting Controller
 * @summary getCutOffById
 */
export function getCutOffById(params: GetCutOffByIdParams) {
  return request.get<AbstractResponse<object, AccCutOffResponse>>(
    `${URL}/api/cutoffbyid` + prepareQueryParams({ cutid: params.cutid } as any)
  );
}
export interface CutOffByCriteriaParams {
  accountingreference: string;
  ctrid: number;
  percode: string;
}

/**
 * @tags Accounting Controller
 * @summary CutOffByCriteria
 */
export function CutOffByCriteria(params: CutOffByCriteriaParams) {
  return request.get<AbstractResponse<object, Acccuttoff>>(
    `${URL}/api/cutoffcriteria` +
      prepareQueryParams({
        accountingreference: params.accountingreference,
        ctrid: params.ctrid,
        percode: params.percode,
      } as any)
  );
}

/**
 * @tags Provision Controller
 * @summary getProvisionListByCriteria
 */
export function getProvisionListByCriteria(
  params: GetProvisionListByCriteriaParams
) {
  return request.get<AbstractResponse<object, Accprovision>>(
    `${URL}/api/provision` +
      prepareQueryParams({
        accountingreference: params.accountingreference,
        jobid: params.jobid,
        percode: params.percode,
        provisioncategory: params.provisioncategory,
        currcode: params.currcode,
        tpid: params.tpid,
      } as any)
  );
}
export interface AddMgprovisionParams {
  request: Mgprovision;
}

/**
 * @tags Mg Provision Controller
 * @summary AddMgprovision
 */
export function AddMgprovision(params: AddMgprovisionParams) {
  return request.post<AbstractResponse<Mgprovision, object>>(
    `${URL}/api/mgprovision`,
    params.request
  );
}

export interface UpdateMgprovisionParams {
  mgprovid: number;
  request: Mgprovision;
}

/**
 * @tags Mg Provision Controller
 * @summary UpdateMgprovision
 */
export function UpdateMgprovision(params: UpdateMgprovisionParams) {
  return request.put<AbstractResponse<Mgprovision, object>>(
    `${URL}/api/mgprovision/${params.mgprovid}`,
    params.request
  );
}
export interface RemoveMgprovisionParams {
  mgprovid: number;
}

/**
 * @tags Mg Provision Controller
 * @summary RemoveMgprovision
 */
export function RemoveMgprovision(params: RemoveMgprovisionParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/mgprovision/${params.mgprovid}`
  );
}

export interface GetMgprovisionListParams {
  initclass: string;
  mgid: number;
  targetclass: string;
}


/**
 * @tags Mg Provision Controller
 * @summary getMgprovisionList
 */
export function getMgprovisionList (params: GetMgprovisionListParams) {
  return request.get<AbstractResponse<object,MgprovisionResponse>>(`${URL}/api/mgprovision` + prepareQueryParams({initclass: params.initclass, mgid: params.mgid, targetclass: params.targetclass} as any))
}

/**
 * @tags Accounting Controller
 * @summary getParaccaccsubaccountByCriteria
 */
export function getParaccaccsubaccountByCriteria(
  params: GetParaccaccsubaccountByCriteriaParams
) {
  return request.get<AbstractResponse<object, Paraccaccsubaccount>>(
    `${URL}/api/Paraccaccsubaccount` +
      prepareQueryParams({
        accid: params.accid,
        acclabel: params.acclabel,
        accmappingreference: params.accmappingreference,
        accreference: params.accreference,
      } as any)
  );
}

export interface AddParaccaccsubaccountParams {
  request: Paraccaccsubaccount;
}

/**
 * @tags Accounting Controller
 * @summary AddParaccaccsubaccount
 */
export function AddParaccaccsubaccount(params: AddParaccaccsubaccountParams) {
  return request.post<AbstractResponse<object, Paraccaccsubaccount>>(
    `${URL}/api/Paraccaccsubaccount`,
    params.request
  );
}

export interface GetParaccaccsubaccountDetailsByIdParams {
  accid: number;
  accsubid: number;
}

/**
 * @tags Accounting Controller
 * @summary getParaccaccsubaccountDetailsById
 */
export function getParaccaccsubaccountDetailsById(
  params: GetParaccaccsubaccountDetailsByIdParams
) {
  return request.get<AbstractResponse<object, Paraccaccsubaccount>>(
    `${URL}/api/Paraccaccsubaccount/${params.accid}/${params.accsubid}`
  );
}

export interface UpdateParaccaccsubaccountParams {
  accid: number;
  accsubid: number;
  request: Paraccaccsubaccount;
}

/**
 * @tags Accounting Controller
 * @summary UpdateParaccaccsubaccount
 */
export function UpdateParaccaccsubaccount(
  params: UpdateParaccaccsubaccountParams
) {
  return request.put<AbstractResponse<object, Paraccaccsubaccount>>(
    `${URL}/api/Paraccaccsubaccount/${params.accid}/${params.accsubid}`,
    params.request
  );
}

export interface RemoveParaccaccsubaccountParams {
  accid: number;
  accsubid: number;
}

/**
 * @tags Accounting Controller
 * @summary removeParaccaccsubaccount
 */
export function removeParaccaccsubaccount(
  params: RemoveParaccaccsubaccountParams
) {
  return request.delete<AbstractResponse<object, Paraccaccsubaccount>>(
    `${URL}/api/Paraccaccsubaccount/${params.accid}/${params.accsubid}`
  );
}

export interface GetParaccattributeByCriteriaParams {
  accarttributelable: string;
  accattribute: string;
  schoperation: string;
}

/**
 * @tags Accounting Controller
 * @summary getParaccattributeByCriteria
 */
export function getParaccattributeByCriteria(
  params: GetParaccattributeByCriteriaParams
) {
  return request.get<AbstractResponse<object, Paraccattribute>>(
    `${URL}/api/Paraccattribute` +
      prepareQueryParams({
        accarttributelable: params.accarttributelable,
        accattribute: params.accattribute,
        schoperation: params.schoperation,
      } as any)
  );
}

export interface AddParaccattributeParams {
  request: Paraccattribute;
}

/**
 * @tags Accounting Controller
 * @summary AddParaccattribute
 */
export function AddParaccattribute(params: AddParaccattributeParams) {
  return request.post<AbstractResponse<object, Paraccattribute>>(
    `${URL}/api/Paraccattribute`,
    params.request
  );
}

export interface GetListParaccattributeDetailsByIdParams {
  attid: number;
}

/**
 * @tags Accounting Controller
 * @summary getListParaccattributeDetailsById
 */
export function getListParaccattributeDetailsById(
  params: GetListParaccattributeDetailsByIdParams
) {
  return request.get<AbstractResponse<object, Paraccattribute>>(
    `${URL}/api/Paraccattribute/${params.attid}`
  );
}

export interface UpdateParaccattributeParams {
  attid: number;
  request: Paraccattribute;
}

/**
 * @tags Accounting Controller
 * @summary UpdateParaccattribute
 */
export function UpdateParaccattribute(params: UpdateParaccattributeParams) {
  return request.put<AbstractResponse<object, Paraccattribute>>(
    `${URL}/api/Paraccattribute/${params.attid}`,
    params.request
  );
}

export interface RemoveParaccattributeParams {
  attid: number;
}

/**
 * @tags Accounting Controller
 * @summary removeParaccattribute
 */
export function removeParaccattribute(params: RemoveParaccattributeParams) {
  return request.delete<AbstractResponse<object, Paraccattribute>>(
    `${URL}/api/Paraccattribute/${params.attid}`
  );
}

export interface GetParAccaccountByCriteriaParams {
  accclass: string;
  acclabel: string;
  accmappingreference: string;
  accmodel: string;
  accreference: string;
  acctype: string;
  mgid: number;
}

/**
 * @tags Accounting Controller
 * @summary getParAccaccountByCriteria
 */
export function getParAccaccountByCriteria(
  params: GetParAccaccountByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParAccaccount>>(
    `${URL}/api/Paraccount` +
      prepareQueryParams({
        accclass: params.accclass,
        acclabel: params.acclabel,
        accmappingreference: params.accmappingreference,
        accmodel: params.accmodel,
        accreference: params.accreference,
        acctype: params.acctype,
        mgid: params.mgid,
      } as any)
  );
}

export interface AddParAccaccountParams {
  request: ParAccaccount;
}

/**
 * @tags Accounting Controller
 * @summary AddParAccaccount
 */
export function AddParAccaccount(params: AddParAccaccountParams) {
  return request.post<AbstractResponse<object, ParAccaccount>>(
    `${URL}/api/Paraccount`,
    params.request
  );
}

export interface GetParAccaccountDetailsByIdParams {
  accid: number;
}

/**
 * @tags Accounting Controller
 * @summary getParAccaccountDetailsById
 */
export function getParAccaccountDetailsById(
  params: GetParAccaccountDetailsByIdParams
) {
  return request.get<AbstractResponse<object, ParAccaccount>>(
    `${URL}/api/Paraccount/${params.accid}`
  );
}

export interface UpdateParAccaccountParams {
  accid: number;
  request: ParAccaccount;
}

/**
 * @tags Accounting Controller
 * @summary UpdateParAccaccount
 */
export function UpdateParAccaccount(params: UpdateParAccaccountParams) {
  return request.put<AbstractResponse<object, ParAccaccount>>(
    `${URL}/api/Paraccount/${params.accid}`,
    params.request
  );
}

export interface RemoveParAccaccountParams {
  accid: number;
}

/**
 * @tags Accounting Controller
 * @summary removeParAccaccount
 */
export function removeParAccaccount(params: RemoveParAccaccountParams) {
  return request.delete<AbstractResponse<object, ParAccaccount>>(
    `${URL}/api/Paraccount/${params.accid}`
  );
}

export interface GetParaccschemaByCriteriaParams {
  accjournal: string;
  accmodel: string;
  acctype: string;
  mgid: number;
  schid: number;
  schlabel: string;
  schoperation: string;
}


/**
 * @tags Accounting Controller
 * @summary getParaccschemaByCriteria
 */
export function getParaccschemaByCriteria (params: GetParaccschemaByCriteriaParams) {
  return request.get<AbstractResponse<object,ParaccshemaResponse>>(`${URL}/api/Paraccschema` + prepareQueryParams({accjournal: params.accjournal, accmodel: params.accmodel, acctype: params.acctype, mgid: params.mgid, schid: params.schid, schlabel: params.schlabel, schoperation: params.schoperation} as any))
}

export interface AddParaccschemaParams {
  request: Paraccschema;
}

/**
 * @tags Accounting Controller
 * @summary AddParaccschema
 */
export function AddParaccschema(params: AddParaccschemaParams) {
  return request.post<AbstractResponse<object, Paraccschema>>(
    `${URL}/api/Paraccschema`,
    params.request
  );
}

export interface GetParaccschemaDetailsByIdParams {
  schid: number;
}

/**
 * @tags Accounting Controller
 * @summary getParaccschemaDetailsById
 */
export function getParaccschemaDetailsById(
  params: GetParaccschemaDetailsByIdParams
) {
  return request.get<AbstractResponse<object, Paraccschema>>(
    `${URL}/api/Paraccschema/${params.schid}`
  );
}

export interface UpdateParaccschemaParams {
  request: Paraccschema;
  schid: number;
}

/**
 * @tags Accounting Controller
 * @summary UpdateParaccschema
 */
export function UpdateParaccschema(params: UpdateParaccschemaParams) {
  return request.put<AbstractResponse<object, Paraccschema>>(
    `${URL}/api/Paraccschema/${params.schid}`,
    params.request
  );
}

export interface RemoveParaccschemaParams {
  schid: number;
}

/**
 * @tags Accounting Controller
 * @summary removeParaccschema
 */
export function removeParaccschema(params: RemoveParaccschemaParams) {
  return request.delete<AbstractResponse<object, Paraccschema>>(
    `${URL}/api/Paraccschema/${params.schid}`
  );
}

export interface AddParaccschlineParams {
  request: Paraccschline;
}

/**
 * @tags Accounting Controller
 * @summary AddParaccschline
 */
export function AddParaccschline(params: AddParaccschlineParams) {
  return request.post<AbstractResponse<Paraccschline, object>>(
    `${URL}/api/Paraccschline`,
    params.request
  );
}

export interface GetSchemaLinesBySchidParams {
  schid: number;
}

/**
 * @tags Accounting Controller
 * @summary getSchemaLinesBySchid
 */
export function getSchemaLinesBySchid(params: GetSchemaLinesBySchidParams) {
  return request.get<AbstractResponse<object, ParaccschlineResponse>>(
    `${URL}/api/Paraccschline/${params.schid}`
  );
}

export interface GetParaccschlineDetailsByIdParams {
  schid: number;
  schlineid: number;
}

/**
 * @tags Accounting Controller
 * @summary getParaccschlineDetailsById
 */
export function getParaccschlineDetailsById(
  params: GetParaccschlineDetailsByIdParams
) {
  return request.get<AbstractResponse<object, Paraccschline>>(
    `${URL}/api/Paraccschline/${params.schid}/${params.schlineid}`
  );
}

export interface UpdateParaccschlineParams {
  request: Paraccschline;
  schid?: number;
  schlineid?: number;
}

/**
 * @tags Accounting Controller
 * @summary UpdateParaccschline
 */
export function UpdateParaccschline(params: UpdateParaccschlineParams) {
  return request.put<AbstractResponse<object, Paraccschline>>(
    `${URL}/api/Paraccschline/${params.schid}/${params.schlineid}`,
    params.request
  );
}

export interface RemoveParaccschlineParams {
  schid: number;
  schlineid: number;
}

/**
 * @tags Accounting Controller
 * @summary removeParaccschline
 */
export function removeParaccschline(params: RemoveParaccschlineParams) {
  return request.delete<AbstractResponse<object, Paraccschline>>(
    `${URL}/api/Paraccschline/${params.schid}/${params.schlineid}`
  );
}

export interface GetAuditByCriteriaParams {
  accmodel: string;
  accreference: string;
  accsubreference: string;
  ctreference: string;
  percode: string;
  schoperation: string;
}

/**
 * @tags Accounting Controller
 * @summary getAuditByCriteria
 */
export function getAuditByCriteria(params: GetAuditByCriteriaParams) {
  return request.get<AbstractResponse<object, AccAudit>>(
    `${URL}/api/accounting/audit` +
      prepareQueryParams({
        accmodel: params.accmodel,
        accreference: params.accreference,
        accsubreference: params.accsubreference,
        ctreference: params.ctreference,
        percode: params.percode,
        schoperation: params.schoperation,
      } as any)
  );
}

export interface GetAccountingEntriesListByCriteriaParams {
  accmodel: string;
  accreference: string;
  assetid: number;
  ciid: number;
  ctrid: number;
  enddate: string;
  flagaudit: boolean;
  payid: number;
  schoperation: string;
  siid: number;
  startdate: string;
  tpid: number;
}

/**
 * @tags Accounting Controller
 * @summary getAccountingEntriesListByCriteria
 */
export function getAccountingEntriesListByCriteria(
  params: GetAccountingEntriesListByCriteriaParams
) {
  return request.get<AbstractResponse<object, EntriesResponse>>(
    `${URL}/api/accounting/entries` +
      prepareQueryParams({
        accmodel: params.accmodel,
        accreference: params.accreference,
        assetid: params.assetid,
        ciid: params.ciid,
        ctrid: params.ctrid,
        enddate: params.enddate,
        flagaudit: params.flagaudit,
        payid: params.payid,
        schoperation: params.schoperation,
        siid: params.siid,
        startdate: params.startdate,
        tpid: params.tpid
      } as any)
  );
}

export interface GetAccountingEntryByAccReferenceParams {
  accreference: string;
}

/**
 * @tags Accounting Controller
 * @summary getAccountingEntryByAccReference
 */
export function getAccountingEntryByAccReference(
  params: GetAccountingEntryByAccReferenceParams
) {
  return request.get<AbstractResponse<object, ACCList>>(
    `${URL}/api/accounting/entries/${params.accreference}`
  );
}

export interface GenAccEntryParams {
  accmodel: string;
  objectid: number;
  objecttype: string;
  operation: string;
}

/**
 * @tags Accounting Controller
 * @summary genAccEntry
 */
export function genAccEntry(params: GenAccEntryParams) {
  return request.get<AbstractResponse<object, ACCList>>(
    `${URL}/api/accounting/genAccEntryByObject` +
      prepareQueryParams({
        accmodel: params.accmodel,
        objectid: params.objectid,
        objecttype: params.objecttype,
        operation: params.operation,
      } as any)
  );
}

export interface GetPeriodByCriteriaParams {
  execode: string;
  percode: string;
  perstatus: string;
  peryear: number;
}

/**
 * @tags Accounting Controller
 * @summary getPeriodByCriteria
 */
export function getPeriodByCriteria(params: GetPeriodByCriteriaParams) {
  return request.get<AbstractResponse<object, AccPeriodResponse>>(
    `${URL}/api/accounting/period` +
      prepareQueryParams({
        execode: params.execode,
        percode: params.percode,
        perstatus: params.perstatus,
        peryear: params.peryear,
      } as any)
  );
}

export interface AddParAccPeriodParams {
  request: AccPeriodResponse;
}


/**
 * @tags Accounting Controller
 * @summary AddParAccPeriod
 */
export function AddParAccPeriod (params: AddParAccPeriodParams) {
  return request.post<AbstractResponse<AccPeriodResponse,object>>(`${URL}/api/accounting/period`, params.request)
}

export interface UpdateParAccPeriodParams {
  percode: string;
  request: ParAccPeriod;
}


/**
 * @tags Accounting Controller
 * @summary UpdateParAccPeriod
 */
export function UpdateParAccPeriod (params: UpdateParAccPeriodParams) {
  return request.put<AbstractResponse<AccPeriodResponse,object>>(`${URL}/api/accounting/period/${params.percode}`, params.request)
}

export interface RemoveParAccPeriodParams {
  percode: string;
}


/**
 * @tags Accounting Controller
 * @summary removeParAccPeriod
 */
export function removeParAccPeriod (params: RemoveParAccPeriodParams) {
  return request.delete<AbstractResponse<ParAccPeriod,object>>(`${URL}/api/accounting/period/${params.percode}`)
}

export interface GenAuditEntriesByAccReferenceParams {
  accreference: string;
  duedate: string;
  jobid?: number;
  mgid?: number;
}


export interface UpdateExerciceStatusParams {
  execode: string;
  status: string;
}

export interface GetExerciceByCriteriaParams {
  execode?: string;
  exestatus?: string;
  exeyear?: string;
}


/**
 * @tags Accounting Controller
 * @summary getExerciceByCriteria
 */
export function getExerciceByCriteria (params: GetExerciceByCriteriaParams) {
  return request.get<AbstractResponse<object,ParAccExerciceResponse>>(`${URL}/api/accounting/exercice` + prepareQueryParams({execode: params.execode, exestatus: params.exestatus, exeyear: params.exeyear} as any))
}

export interface AddParAccExerciceParams {
  request: ParAccExerciceResponse;
}


/**
 * @tags Accounting Controller
 * @summary AddParAccExercice
 */
export function AddParAccExercice (params: AddParAccExerciceParams) {
  return request.post<AbstractResponse<ParAccExerciceResponse,object>>(`${URL}/api/accounting/exercice`, params.request)
}

export interface UpdateParAccExerciceParams {
  execode: string;
  request: ParAccExercice;
}


/**
 * @tags Accounting Controller
 * @summary UpdateParAccExercice
 */
export function UpdateParAccExercice (params: UpdateParAccExerciceParams) {
  return request.put<AbstractResponse<ParAccExerciceResponse,object>>(`${URL}/api/accounting/exercice/${params.execode}`, params.request)
}

export interface RemoveParAccExerciceParams {
  execode: string;
}


/**
 * @tags Accounting Controller
 * @summary removeParAccExercice
 */
export function removeParAccExercice (params: RemoveParAccExerciceParams) {
  return request.delete<AbstractResponse<ParAccExercice,object>>(`${URL}/api/accounting/exercice/${params.execode}`)
}


/**
 * @tags Accounting Controller
 * @summary updateExerciceStatus
 */
export function updateExerciceStatus (params: UpdateExerciceStatusParams) {
  return request.put<AbstractResponse<ParAccExercice,object>>(`${URL}/api/accounting/run/exercice` + prepareQueryParams({execode: params.execode, status: params.status} as any))
}

/**
 * @tags Accounting Controller
 * @summary genAuditEntriesByAccReference
 */
export function genAuditEntriesByAccReference(
  params: GenAuditEntriesByAccReferenceParams
) {
  return request.get<JobExecutionResponse>(
    `${URL}/api/accounting/run/audit` +
      prepareQueryParams({
        accreference: params.accreference,
        duedate: params.duedate,
        jobid: params.jobid,
        mgid: params.mgid,
      } as any)
  );
}

export interface GenBalanceParams {
  ctridend: number;
  ctridstart: number;
  jobid?: number;
  mgid: number;
  percode: string;
}

/**
 * @tags Accounting Controller
 * @summary genBalance
 */
export function genBalance(params: GenBalanceParams) {
  return request.get<JobExecutionResponse>(
    `${URL}/api/accounting/run/balance` +
      prepareQueryParams({
        ctridend: params.ctridend,
        ctridstart: params.ctridstart,
        jobid: params.jobid,
        mgid: params.mgid,
        percode: params.percode,
      } as any)
  );
}

export interface GenAccEntryByContractParams {
  ctridend: number;
  ctridstart: number;
  duedate: string;
  jobid?: number;
  mgid?: number;
}

/**
 * @tags Accounting Controller
 * @summary genAccEntryByContract
 */
export function genAccEntryByContract(params: GenAccEntryByContractParams) {
  return request.get<JobExecutionResponse>(
    `${URL}/api/accounting/run/entries` +
      prepareQueryParams({
        ctridend: params.ctridend,
        ctridstart: params.ctridstart,
        duedate: params.duedate,
        jobid: params.jobid,
        mgid: params.mgid,
      } as any)
  );
}

export interface GenAccEntryJobErrorsParams {
  duedate: string;
  jobid: number;
}

/**
 * @tags Accounting Controller
 * @summary genAccEntryJobErrors
 */
export function genAccEntryJobErrors(params: GenAccEntryJobErrorsParams) {
  return request.get<JobExecutionResponse>(
    `${URL}/api/accounting/run/entriesErrors` +
      prepareQueryParams({
        duedate: params.duedate,
        jobid: params.jobid,
      } as any)
  );
}

export interface ExtractAccountingFileParams {
  accdate: string;
  accmodel: string;
  companycode: string;
  jobid?: number;
  mgid?: number;
  percode: string;
  schoperation: string;
  flagextractTpData:boolean;
}

/**
 * @tags Accounting Controller
 * @summary extractAccountingFile
 */
export function extractAccountingFile(params: ExtractAccountingFileParams) {
  return request.get<JobExecutionResponse>(
    `${URL}/api/accounting/run/extract` +
      prepareQueryParams({
        accdate: params.accdate,
        accmodel: params.accmodel,
        companycode: params.companycode,
        jobid: params.jobid,
        mgid: params.mgid,
        percode: params.percode,
        schoperation: params.schoperation,
        flagextractTpData:params.flagextractTpData,
      } as any)
  );
}

export interface UpdatePeriodStatusParams {
  jobid?: number;
  percode: string;
  status: string;
}

/**
 * @tags Accounting Controller
 * @summary updatePeriodStatus
 */
export function updatePeriodStatus(params: UpdatePeriodStatusParams) {
  return request.put<AbstractResponse<ParAccPeriod, object>>(
    `${URL}/api/accounting/run/period` +
      prepareQueryParams({
        jobid: params.jobid,
        percode: params.percode,
        status: params.status,
      } as any)
  );
}

export interface GetAccountingEntriesBySchoperationParams {
  accmodel: string;
  objectid: number;
  schoperation: string;
}

/**
 * @tags Accounting Controller
 * @summary Get accounting entries by Operation. returns .list
 */
export function getAccountingEntriesBySchoperation(
  params: GetAccountingEntriesBySchoperationParams
) {
  return request.get<AbstractResponse<object, ACCList>>(
    `${URL}/api/accountingEntries/byOperation` +
      prepareQueryParams({
        accmodel: params.accmodel,
        objectid: params.objectid,
        schoperation: params.schoperation,
      } as any)
  );
}

export interface GetAccEventssByEventtypeParams {
  eventtype: string;
  objectid: number;
  objecttype: string;
}

/**
 * @tags Accounting Controller
 * @summary getAccEventssByEventtype
 */
export function getAccEventssByEventtype(
  params: GetAccEventssByEventtypeParams
) {
  return request.get<AbstractResponse<object, AccEventsResponse>>(
    `${URL}/api/accountingEvents` +
      prepareQueryParams({
        eventtype: params.eventtype,
        objectid: params.objectid,
        objecttype: params.objecttype,
      } as any)
  );
}

export interface GetAccEventsContractActivationParams {
  ctrid: number;
  datemax: string;
  datemin: string;
  eventcategory: string;
  eventstatus: string;
  eventtype: string;
}

/**
 * @tags Accounting Controller
 * @summary getAccEventsContractActivation
 */
export function getAccEventsContractActivation(
  params: GetAccEventsContractActivationParams
) {
  return request.get<AbstractResponse<object, AccEvents>>(
    `${URL}/api/accountingEvents/contractActivation` +
      prepareQueryParams({
        ctrid: params.ctrid,
        datemax: params.datemax,
        datemin: params.datemin,
        eventcategory: params.eventcategory,
        eventstatus: params.eventstatus,
        eventtype: params.eventtype,
      } as any)
  );
}

export interface GetBalanceByCriteriaParams {
  accmodel: string;
  accreference: string;
  accsubreference: string;
  auxiliarycode: string;
  axe1: string;
  axe2: string;
  companycode: string;
  ctreference: string;
  journal: string;
  mgid: number;
  percode: string;
}

/**
 * @tags Accounting Controller
 * @summary getBalanceByCriteria
 */
export function getBalanceByCriteria(params: GetBalanceByCriteriaParams) {
  return request.get<AbstractResponse<object, AccBalance>>(
    `${URL}/api/balance` +
      prepareQueryParams({
        accmodel: params.accmodel,
        accreference: params.accreference,
        accsubreference: params.accsubreference,
        auxiliarycode: params.auxiliarycode,
        axe1: params.axe1,
        axe2: params.axe2,
        companycode: params.companycode,
        ctreference: params.ctreference,
        journal: params.journal,
        mgid: params.mgid,
        percode: params.percode,
      } as any)
  );
}

export interface GetContractAssetDepreciationParams {
  ctrid: number;
  deprcontext: string;
  enddate: string;
  startdate: string;
}

/**
 * @tags Accounting Controller
 * @summary getContractAssetDepreciation
 */
export function getContractAssetDepreciation(
  params: GetContractAssetDepreciationParams
) {
  return request.get<AbstractResponse<object, ViewAssetDepreciation>>(
    `${URL}/api/depreciation` +
      prepareQueryParams({
        ctrid: params.ctrid,
        deprcontext: params.deprcontext,
        enddate: params.enddate,
        startdate: params.startdate,
      } as any)
  );
}

export interface GetJobListByCriteriaParams {
  servicename: string;
  startdate: string;
  status: string;
}

/**
 * @tags Batch Job Execution Controller
 * @summary getJobListByCriteria
 */
export function getJobListByCriteriaAccounting(
  params: GetJobListByCriteriaParams
) {
  return request.get<AbstractResponse<object, BatchJobExecution>>(
    `${URL}/api/job` +
      prepareQueryParams({
        servicename: params.servicename,
        startdate: params.startdate,
        status: params.status,
      } as any)
  );
}

export interface DownloadFileParams {
  filetype: string;
  jobid: number;
}

/**
 * @tags Batch Job Execution Controller
 * @summary downloadFile
 */
export function downloadFile(params: DownloadFileParams) {
  return request.get<Resource>(
    `${URL}/api/job/download` +
      prepareQueryParams({
        filetype: params.filetype,
        jobid: params.jobid,
      } as any)
  );
}

export interface GetModuleServiceListParams {
  module: string;
}

/**
 * @tags Batch Job Execution Controller
 * @summary getModuleServiceList
 */
export function getModuleServiceList(params: GetModuleServiceListParams) {
  return request.get<AbstractResponse<object, ParFunctionLabel>>(
    `${URL}/api/service/list` +
      prepareQueryParams({ module: params.module } as any)
  );
}

export interface GetContractSpreadingParams {
  ctrid: number;
  ctscategory: string;
  ctsdirection: string;
  ctsstatus: string;
  ctstype: string;
  datemax: string;
  datemin: string;
}

/**
 * @tags Accounting Controller
 * @summary getContractSpreading
 */
export function getContractSpreading(params: GetContractSpreadingParams) {
  return request.get<AbstractResponse<object, FinConElemSpreading>>(
    `${URL}/api/spreading` +
      prepareQueryParams({
        ctrid: params.ctrid,
        ctscategory: params.ctscategory,
        ctsdirection: params.ctsdirection,
        ctsstatus: params.ctsstatus,
        ctstype: params.ctstype,
        datemax: params.datemax,
        datemin: params.datemin,
      } as any)
  );
}

export interface UpdateProvisionParams {
  provid: number;
  request: Accprovision;
}

/**
 * @tags Provision Controller
 * @summary UpdateProvision
 */
export function UpdateProvision(params: UpdateProvisionParams) {
  return request.put<AbstractResponse<Accprovision, object>>(
    `${URL}/api/provision/${params.provid}`,
    params.request
  );
}

export interface GetProvisiondetailsParams {
  provid: number;
}

/**
 * @tags Provision Controller
 * @summary getProvisiondetails
 */
export function getProvisiondetails(params: GetProvisiondetailsParams) {
  return request.get<AbstractResponse<object, AccprovisionDetail>>(
    `${URL}/api/provision/${params.provid}`
  );
}

export interface CalculateProvisionParams {
  flagupdateClass?: boolean;
  percode: string;
  tpidend: number;
  tpidstart: number;
}

/**
 * @tags Provision Controller
 * @summary calculateProvision
 */
export function calculateProvision(params: CalculateProvisionParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/run/calculate/provision` +
      prepareQueryParams({
        flagupdateClass: params.flagupdateClass,
        percode: params.percode,
        tpidend: params.tpidend,
        tpidstart: params.tpidstart,
      } as any)
  );
}

/**
 * @tags Accounting Controller
 * @summary version
 */
export function version() {
  return request.get<string>(`${URL}/api/version`);
}

export interface RunCalculateCuttoffParams {
  mgid: number;
  percode: string;
}

/**
 * @tags Accounting Controller
 * @summary RunCalculateCuttoff
 */
export function RunCalculateCuttoff(params: RunCalculateCuttoffParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/run/calculateCuttoff` +
      prepareQueryParams({ mgid: params.mgid, percode: params.percode } as any)
  );
}
export interface AddAccEntriesParams {
  request: Array<AccEntriesResponse>;
};


/**
 * @tags Accounting Controller
 * @summary AddAccEntries
 */
export function AddAccEntries (params: AddAccEntriesParams) {
  return request.post<AbstractResponse<object,AccEntriesResponse>>(`${URL}/api/accounting/accentries`, params.request)
};
